import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d5ty4bqhca: FaireBrandEntity = {
  token: "b_d5ty4bqhca",
  type: "brand",
  name: "Salty But Sweet",
  avatarUrl:
    "https://cdn.faire.com/fastly/8ddc2f51e8b32b76e06a7ecb10de394233e1bc7427ecf91ba879ec6c1f84c0cf.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/621168d1925a415bb09553db39aeaeb88b29a49c8d7d56c50de398c1b5c14c13.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8ddc2f51e8b32b76e06a7ecb10de394233e1bc7427ecf91ba879ec6c1f84c0cf.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/621168d1925a415bb09553db39aeaeb88b29a49c8d7d56c50de398c1b5c14c13.jpeg",
  location: "Honolulu, HI, USA",
  minimumOrderDollars: 206,
  rating: 5,
  reviewCount: 64,
  isTopShop: true,
  isInsider: false,
  description:
    "Aloha! I’m Kim, owner & designer of Salty But Sweet, an ocean inspired jewelry line from the island of Oahu, where I was born and raised.\nI offer affordable and unique quality pieces that are ideal for any age.\nMy “Salty but Sweet” designs are inspired by my affinity for the ocean and the beauty of the islands I call home. I hope by wearing my designs it allows your customers to carry a little piece of the islands wherever they go.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T02:38:56.200Z",
    importedBy: "entity-db-cli",
  },
};
